module.exports = __webpack_public_path__ + "static/media/cassina.f7648aac.svg";